import React, { FC, useEffect, useState } from "react";

import {
  Card,
  CardBody,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  UncontrolledDropdown,
} from "reactstrap";
import { Link } from "react-router-dom";

import Profiletab2 from "./ProfilTab2";
import ProfileTab1 from "./ProfilTab1";
import CustomerPaymentModal from "./CustomerPaymentModal";
import CustomerDeleteModal from "./CustomerDeleteModal";
import CustomerMaintenanceHistoryModal from "./CustomerMaintenanceHistoryModal";
import { getItem } from "../../shared/hooks/useCookie";
import {
  useCustomerAllPaymentMutation,
  useCustomerProfileMutation,
} from "./CustomerProfile.actions";
import CustomerMaintenanceModal from "./CustomerMaintenanceModal";
import { useRecoilValue } from "recoil";
import {
  isLoggedInSelector,
  permissionsSelector,
} from "../../shared/actions/Authentication.actions";
import { Permissions } from "../../shared/models/Types";
import {
  postMessageCall,
  postMessageLocation,
  postMessageSms,
  postMessageWp,
} from "../../shared/internals/asd";
import { webViewSelector } from "../../shared/actions/LayoutMode.actions";
import CustomerUpdateModal from "./CustomerUpdateModal";
import { useSmsMutation } from "../Company/Company.actions";

const CustomerProfileDetail: FC = () => {
  document.title =
    "Müşteri Bilgisi | Bu ekranda müşteri bilgileri düzenlemesi yapabilirsiniz";
  const permissionList = useRecoilValue(permissionsSelector);
  const { company } = useRecoilValue(isLoggedInSelector);

  const isMobile: boolean = /iPhone|iPad|iPod|Android/i.test(
    navigator.userAgent
  );

  const { data, mutate, isLoading } = useCustomerProfileMutation();
  const { data: smsData, mutate: smsMutate } = useSmsMutation();
  const { data: customerAllPaymentData, mutate: customerAllPaymentMutation } =
    useCustomerAllPaymentMutation();

  const customerProfileId = getItem("customerProfileId");

  const isWebView = useRecoilValue(webViewSelector);
  const [activeTab, toggleTab] = useState("1");
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState<boolean>(false);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState<boolean>(false);
  const [isMaintanenceModalOpen, setIsMaintanenceModalOpen] =
    useState<boolean>(false);

  useEffect(() => {
    mutate({ id: customerProfileId });
    smsMutate({});
    customerAllPaymentMutation({ id: customerProfileId });
  }, []);

  const toggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  const toggleDelete = () => {
    setIsDeleteModalOpen(!isDeleteModalOpen);
  };

  const toggleUpdate = () => {
    setIsUpdateModalOpen(!isUpdateModalOpen);
  };

  const toggleHistory = () => {
    setIsHistoryModalOpen(!isHistoryModalOpen);
  };

  const toggleMaintanence = () => {
    setIsMaintanenceModalOpen(!isMaintanenceModalOpen);
  };

  const deleteCustomerPermission = permissionList[Permissions.DeleteCustomer];
  const updateCustomerPermission = permissionList[Permissions.ChangeCustomer];

  const maintenanceSms = smsData?.find(
    (item) => item.content_type === "maintenance"
  );

  const paymentSms = smsData?.find((item) => item.content_type === "payment");

  let smsRetrival = 0;

  customerAllPaymentData?.results.forEach((result) => {
    smsRetrival += parseFloat(result.retrieval);
  });

  return (
    <React.Fragment>
      <Row>
        {/* <Col xl={9} lg={8}> */}
        {data?.detail ? (
          "Müşteri Silinmiş"
        ) : (
          <Col xl={12} lg={12}>
            <Card>
              <CardBody>
                <Row>
                  <div className="col-sm order-2 order-sm-1">
                    <div className="d-flex align-items-start mt-3 mt-sm-0">
                      <div className="avatar-lg d-inline-block align-middle me-2">
                        <div
                          style={{ fontSize: 64 }}
                          className="avatar-title bg-light-subtle text-light font-size-64 m-0 rounded-circle"
                        >
                          <i className="bx bxs-user-circle"></i>
                        </div>
                      </div>

                      <div className="flex-grow-1">
                        <div>
                          <h5 className="font-size-16 mb-1">
                            {!isLoading ? (
                              data?.fullname
                            ) : (
                              <span className="placeholder col-3"></span>
                            )}

                            {!isLoading && !data?.is_visible && (
                              <div
                                className={
                                  "badge bg-" +
                                  "danger" +
                                  "-subtle text-" +
                                  "danger" +
                                  " font-size-12 m-1"
                                }
                              >
                                {"Pasif"}
                              </div>
                            )}
                          </h5>

                          <p className="text-bold font-size-13">
                            {!isLoading ? (
                              `${data?.phone_number} ${data?.phone_number2} ${data?.phone_number3}`
                            ) : (
                              <span className="placeholder col-4"></span>
                            )}
                          </p>
                          <p className="text-muted font-size-13">
                            {!isLoading ? (
                              `${data?.neighbourhood} ${data?.street} ${data?.flat_number} ${data?.country} ${data?.district}`
                            ) : (
                              <span className="placeholder col-7"></span>
                            )}
                          </p>

                          <p className="text-muted font-size-13">
                            {!isLoading ? (
                              `${data?.address_description}`
                            ) : (
                              <span className="placeholder col-6"></span>
                            )}
                          </p>

                          {!isLoading &&
                            (data?.sms_returned_back ? (
                              <div
                                className={
                                  "badge bg-" +
                                  "success" +
                                  "-subtle text-" +
                                  "success" +
                                  " font-size-12"
                                }
                              >
                                {"Sms Geri Dönüş Yapıldı"}
                              </div>
                            ) : (
                              <div
                                className={
                                  "badge bg-" +
                                  "warning" +
                                  "-subtle text-" +
                                  "warning" +
                                  " font-size-12"
                                }
                              >
                                {"Sms Geri Dönüş Yapılmadı"}
                              </div>
                            ))}

                          {/* <div className="d-flex flex-wrap align-items-start gap-2 gap-lg-3 text-muted font-size-13">
                          <div>
                            {data?.email && (
                              <Link to="mailto:email@example.com" type="button" className="">
                                {data?.email}
                              </Link>
                            )}
                          </div>
                        </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-auto order-1 order-sm-2">
                    <div className="d-flex align-items-start justify-content-between gap-2 mb-3">
                      <div>
                        <button
                          onClick={toggle}
                          type="button"
                          className="btn btn-soft-primary"
                        >
                          <i className="bx bx-credit-card me-1"></i>
                        </button>
                      </div>

                      {isWebView && (
                        <div>
                          <Link
                            onClick={() => {
                              postMessageCall(`${data?.phone_number}`);
                            }}
                            to={"#"}
                            type="button"
                            className="btn btn-soft-success"
                          >
                            <i className="bx bx-phone-call"></i>
                          </Link>
                        </div>
                      )}

                      {isWebView && (
                        <div>
                          <Link
                            to={"#"}
                            onClick={() =>
                              postMessageLocation(`${data?.lang}@${data?.long}`)
                            }
                            type="button"
                            className="btn btn-soft-success"
                          >
                            <i className="bx bx-current-location"></i>
                          </Link>
                        </div>
                      )}

                      {isWebView && (
                        <div>
                          <UncontrolledDropdown>
                            <DropdownToggle
                              className="btn btn-soft-warning font-size-32 shadow-none text-muted"
                              tag="a"
                            >
                              <i className="bx bx-envelope"></i>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                              <li>
                                <DropdownItem
                                  onClick={() =>
                                    postMessageSms(
                                      `${data?.phone_number}@${
                                        maintenanceSms?.content.length
                                          ? maintenanceSms.content
                                          : "Değerli Müşterimiz, Su Arıtma Cihazınızın bakım zamanı gelmiştir. En yakın zamanda bizimle iletişime geçmenizi önemle rica ediyoruz."
                                      } \n ${company?.name} \n ${
                                        company?.phone_number1
                                          ? company?.phone_number1
                                          : ""
                                      } ${
                                        company?.phone_number2
                                          ? "\n " + company.phone_number2
                                          : ""
                                      } ${
                                        company?.phone_number3
                                          ? "\n " + company.phone_number3
                                          : ""
                                      }`
                                    )
                                  }
                                  href={"#"}
                                >
                                  Bakım Zamanı
                                </DropdownItem>
                              </li>
                              <li>
                                <DropdownItem
                                  onClick={() =>
                                    postMessageSms(
                                      `${data?.phone_number}@${
                                        paymentSms?.content.length
                                          ? paymentSms.content.replace(
                                              "$borc",
                                              smsRetrival.toString()
                                            )
                                          : `Değerli Müşterimiz, Toplam tutar ${smsRetrival} ₺ borcunuz bulunmaktadır. Borcunuzu ödemenizi önemle rica ederiz.`
                                      } \n ${company?.name} \n ${
                                        company?.phone_number1
                                          ? company?.phone_number1
                                          : ""
                                      } ${
                                        company?.phone_number2
                                          ? "\n " + company.phone_number2
                                          : ""
                                      } ${
                                        company?.phone_number3
                                          ? "\n " + company.phone_number3
                                          : ""
                                      }`
                                    )
                                  }
                                  href={"#"}
                                >
                                  Toplam Borç
                                </DropdownItem>
                              </li>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </div>
                      )}

                      {isWebView && (
                        <div>
                          <UncontrolledDropdown>
                            <DropdownToggle
                              className="btn btn-soft-success font-size-32 shadow-none text-muted"
                              tag="a"
                            >
                              <i className="bx bxl-whatsapp"></i>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                              <li>
                                <DropdownItem
                                  onClick={() =>
                                    postMessageWp(
                                      `${data?.phone_number}@${
                                        maintenanceSms?.content.length
                                          ? maintenanceSms.content
                                          : "Değerli Müşterimiz, Su Arıtma Cihazınızın bakım zamanı gelmiştir. En yakın zamanda bizimle iletişime geçmenizi önemle rica ediyoruz."
                                      } \n ${company?.name} \n ${
                                        company?.phone_number1
                                          ? company?.phone_number1
                                          : ""
                                      } ${
                                        company?.phone_number2
                                          ? "\n " + company.phone_number2
                                          : ""
                                      } ${
                                        company?.phone_number3
                                          ? "\n " + company.phone_number3
                                          : ""
                                      }`
                                    )
                                  }
                                  href={"#"}
                                >
                                  Bakım Zamanı
                                </DropdownItem>
                              </li>
                              <li>
                                <DropdownItem
                                  onClick={() =>
                                    postMessageWp(
                                      `${data?.phone_number}@${
                                        paymentSms?.content.length
                                          ? paymentSms.content.replace(
                                              "$borc",
                                              smsRetrival.toString()
                                            )
                                          : `Değerli Müşterimiz, Toplam tutar ${smsRetrival} ₺ borcunuz bulunmaktadır. Borcunuzu ödemenizi önemle rica ederiz.`
                                      } \n ${company?.name} \n ${
                                        company?.phone_number1
                                          ? company?.phone_number1
                                          : ""
                                      } ${
                                        company?.phone_number2
                                          ? "\n " + company.phone_number2
                                          : ""
                                      } ${
                                        company?.phone_number3
                                          ? "\n " + company.phone_number3
                                          : ""
                                      }`
                                    )
                                  }
                                  href={"#"}
                                >
                                  Toplam Borç
                                </DropdownItem>
                              </li>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </div>
                      )}

                      {updateCustomerPermission && (
                        <div>
                          <button
                            onClick={toggleUpdate}
                            type="button"
                            className="btn btn-soft-primary"
                          >
                            <i className="bx bx-cog me-1"></i>
                          </button>
                        </div>
                      )}

                      {deleteCustomerPermission && (
                        <div>
                          <button
                            onClick={toggleDelete}
                            type="button"
                            className="btn btn-soft-danger"
                          >
                            <i className="bx bx-trash me-1"></i>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </Row>

                <Nav className="nav-tabs-custom card-header-tabs border-top mt-4">
                  <NavItem>
                    <NavLink
                      href="#"
                      style={{ fontSize: isMobile ? "0.8rem" : "0.875rem" }}
                      className={`${
                        activeTab === "1" ? "active px-3" : "px-3"
                      }`}
                      onClick={() => {
                        toggleTab("1");
                      }}
                    >
                      Müşteri Bilgisi
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="#"
                      style={{ fontSize: isMobile ? "0.8rem" : "0.875rem" }}
                      className={`${
                        activeTab === "2" ? "active px-3" : "px-3"
                      }`}
                      onClick={() => {
                        toggleTab("2");
                      }}
                    >
                      Ödeme Bilgileri
                    </NavLink>
                  </NavItem>
                </Nav>
              </CardBody>
            </Card>
            <TabContent activeTab={activeTab}>
              <TabPane tabId="1">
                <ProfileTab1
                  data={data}
                  toggleHistory={toggleHistory}
                  toggleMaintanence={toggleMaintanence}
                  mutate={mutate}
                />
              </TabPane>
              <TabPane tabId="2">
                <Profiletab2
                  data={customerAllPaymentData}
                  mutate={customerAllPaymentMutation}
                />
              </TabPane>
            </TabContent>
          </Col>
        )}
        {/* <Col xl={3} lg={4}>
          <Card>
            <CardBody>
              <h5 className="mb-3 card-title">Skills</h5>

              <div className="d-flex flex-wrap gap-2 font-size-16">
                <Link to="#" className="badge bg-primary-subtle text-primary">
                  Photoshop
                </Link>
                <Link to="#" className="badge bg-primary-subtle text-primary">
                  illustrator
                </Link>
                <Link to="#" className="badge bg-primary-subtle text-primary">
                  HTML
                </Link>
                <Link to="#" className="badge bg-primary-subtle text-primary">
                  CSS
                </Link>
                <Link to="#" className="badge bg-primary-subtle text-primary">
                  Javascript
                </Link>
                <Link to="#" className="badge bg-primary-subtle text-primary">
                  Php
                </Link>
                <Link to="#" className="badge bg-primary-subtle text-primary">
                  Python
                </Link>
              </div>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <h5 className="mb-3 card-title">Portfolio</h5>

              <div>
                <ul className="list-unstyled mb-0">
                  <li>
                    <Link to="#" className="py-2 d-block text-muted">
                      <i className="mdi mdi-web text-primary me-1"></i> Website
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="py-2 d-block text-muted">
                      <i className="mdi mdi-note-text-outline text-primary me-1"></i> Blog
                    </Link>
                  </li>
                </ul>
              </div>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              <h5 className="mb-3 card-title">Similar Profiles</h5>

              <div className="list-group list-group-flush">
                <Link to="#" className="list-group-item list-group-item-action">
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0 me-3">
                      <img src={avatar1} alt="" className="img-thumbnail rounded-circle" />
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <h5 className="font-size-14 mb-1">James Nix</h5>
                        <p className="font-size-13 text-muted mb-0">Full Stack Developer</p>
                      </div>
                    </div>
                  </div>
                </Link>
                <Link to="#" className="list-group-item list-group-item-action">
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0 me-3">
                      <img src={avatar3} alt="" className="img-thumbnail rounded-circle" />
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <h5 className="font-size-14 mb-1">Darlene Smith</h5>
                        <p className="font-size-13 text-muted mb-0">UI/UX Designer</p>
                      </div>
                    </div>
                  </div>
                </Link>
                <Link to="#" className="list-group-item list-group-item-action">
                  <div className="d-flex align-items-center">
                    <div className="avatar-sm flex-shrink-0 me-3">
                      <div className="avatar-title bg-light-subtle text-light rounded-circle font-size-22">
                        <i className="bx bxs-user-circle"></i>
                      </div>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <h5 className="font-size-14 mb-1">William Swift</h5>
                        <p className="font-size-13 text-muted mb-0">Backend Developer</p>
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </CardBody>
          </Card>
        </Col> */}
      </Row>

      {isModalOpen && (
        <CustomerPaymentModal
          mutate={mutate}
          customerAllPaymentMutation={customerAllPaymentMutation}
          customerProfilData={data}
          isModalOpen={isModalOpen}
          toggle={toggle}
        />
      )}

      {isDeleteModalOpen && (
        <CustomerDeleteModal
          isModalOpen={isDeleteModalOpen}
          userData={data}
          toggle={toggleDelete}
        />
      )}

      {isHistoryModalOpen && (
        <CustomerMaintenanceHistoryModal
          isModalOpen={isHistoryModalOpen}
          toggle={toggleHistory}
        />
      )}

      {isMaintanenceModalOpen && (
        <CustomerMaintenanceModal
          mutate={mutate}
          customerProfilData={data}
          isModalOpen={isMaintanenceModalOpen}
          toggle={toggleMaintanence}
        />
      )}

      {isUpdateModalOpen && (
        <CustomerUpdateModal
          mutate={mutate}
          userData={data}
          isModalOpen={isUpdateModalOpen}
          toggle={toggleUpdate}
        />
      )}
    </React.Fragment>
  );
};

export default CustomerProfileDetail;
